import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  
} from "react-router-dom";
import ChartPage from './containers/page/chart';
import AddFamily from './containers/addFamilyPages/index';
import AddProductPage from './containers/addProducts/index';
import InformationMember from './containers/informationMember';
// import useUnload from './components/useUnload';

const App = () => {
  
  console.log = () => {};

  // useUnload(e => {
  //   console.log("=====> e:", e);
  //   // e.preventDefault();
  //   // e.returnValue = '';
  // });
  return (
    <Router>
      <Switch>
        <Route path='/' exact component={ChartPage} />
        <Route path='/add-member' component={AddFamily} />
        <Route path='/add-product' component={AddProductPage} />
        <Route path='/info-member' component={InformationMember} />
      </Switch>
    </Router>
  );
}

export default App;